/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosFeedbackRequest } from '../models/AptosFeedbackRequest';
import type { CommonFeedbackRequest } from '../models/CommonFeedbackRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeedbackControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public feedback({
        requestBody,
    }: {
        requestBody: (CommonFeedbackRequest | AptosFeedbackRequest),
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/feedback',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public feedback1({
        requestBody,
    }: {
        requestBody: (CommonFeedbackRequest | AptosFeedbackRequest),
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/feedback',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
